import { render, staticRenderFns } from "./TravelersTablePagination.vue?vue&type=template&id=31a0717c&"
import script from "./TravelersTablePagination.vue?vue&type=script&lang=js&"
export * from "./TravelersTablePagination.vue?vue&type=script&lang=js&"
import style0 from "./TravelersTablePagination.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31a0717c')) {
      api.createRecord('31a0717c', component.options)
    } else {
      api.reload('31a0717c', component.options)
    }
    module.hot.accept("./TravelersTablePagination.vue?vue&type=template&id=31a0717c&", function () {
      api.rerender('31a0717c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/VisitorApprovalPage/components/TravelersTablePagination.vue"
export default component.exports